<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Settings",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Settings",
            items: [
               {
                  text: "Settings",
                  active: true,
               },                   
            ],
            admin_name: "",          
            username: "",
            admin_image: "",

           sigofish_admin:"",
           
           delivery_range:"",
           delivery_cost:"",
           delivery_start:"",
           delivery_end:"",
            
            name: "", 
            country_code_id: "1", 
            mobile: "", 
            email: "",
            password: "",
            password_confirmation: "",

            android_customer_version: "",
            android_driver_version: "",
            ios_customer_version: "",
            ios_driver_version: "",

            maintenance_website: "",
            maintenance_android: "",
            maintenance_ios: "",

            maintenance_reason_website: "",
            maintenance_reason_android: "",
            maintenance_reason_ios: "",

            app_store_link: "",
            app_store_version: "",
            app_store_update: "",
            play_store_link: "",
            play_store_version: "",
            play_store_update: "",
            youtube: "",
            facebook: "",
            twitter: "",
            instagram: "",
            
            token: "",
            errors: {},
            
            show_password: false,
            show_confirm_password: false,

            settings: {},
            admin: {},
            country_codes: [],

            image: '',
            preview_image: null,
           
         };
      },
      mounted() {
    
      },

      created() {
                  this.fetchCountryCodes();

         this.fetchSettings();
      },

      methods: {

         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 
alphaSpacesOnly(event) {
            let keyCode = event.keyCode;
            if ((keyCode >= 65 && keyCode <= 90) || 
               (keyCode >= 97 && keyCode <= 122) ||               
               (keyCode == 32)) {
                 return;
            } else {
               event.preventDefault();
            }
         },
 
         getToken() {
            if (localStorage.getItem('sigofish_admin')) {
               var sigofish_admin =  JSON.parse(localStorage.getItem('sigofish_admin'));
               if(sigofish_admin.token) {
                  this.token = sigofish_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchSettings() {
            let url = "api/admin/settings/index";         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.settings = responseData.settings[0];
               this.admin = responseData.admins[0];

                        
            })
            .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } 
               else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         });
            //.finally(() => (this.loading = false));
         },
         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },
 fetchCountryCodes() {
            let url = "api/get-countrycodes";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.country_codes = responseData.country_codes;
                  console.warn(responseData.country_codes);

               })
               .catch((err) => console.log(err));
         },

        
         updateProfile() {
            this.getToken();
            this.errors = {};
            let formData = new FormData();
         formData.append("name", this.admin.name);
         formData.append("country_code", this.settings.country_code_id); 
         formData.append("mobile", this.admin.mobile); 
          formData.append("username", this.admin.username); 
          formData.append("email", this.admin.email); 
         //  formData.append("address", this.settings.address);           
          formData.append("image", this.image);
            

            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            this.loading = true;            
            
            this.$axios
               .post("api/admin/edit", formData, config)
               .then((response) => {
                  console.log(response);
                  if (response.data.status) {
                     var user = response.data.data.admin;
                     console.log(user);
                     var sigofish_admin = {};
                     if (localStorage.getItem('sigofish_admin')) {
                        sigofish_admin =  JSON.parse(localStorage.getItem('sigofish_admin'));
                     }

                     // sigofish_admin.email = user.email;
                     sigofish_admin.image = user.image;
                     sigofish_admin.name = user.name;
                     sigofish_admin.country_code_id=user.country_code_id;
                     sigofish_admin.mobile = user.mobile;
                     sigofish_admin.address = user.address;
                     sigofish_admin.username = user.username;
                     sigofish_admin.email = user.email;

                     localStorage.setItem('sigofish_admin', JSON.stringify(sigofish_admin));
                     
                     this.$swal("", response.data.message, "success");
                     // this.$router.push({ name: 'settings'});

                  } else {
                        this.$swal("", response.data.message, "error");
                  }

                  // this.clearForm();
                  this.$router.go();  
                
               })
              .catch((error) => {
                  console.log(error);
                  console.log(error.response);
                  if (error.response) {
                     if (error.response.status == 422) {
                     if (error.response.data) {
                        this.errors = error.response.data.message;
                     }
                     this.$swal("", error.response.statusText, "error");
                     } else if (error.response.status == 500) {
                     this.$swal("", error.response.statusText, "error");
                     } else if (error.response.status == 401) {
                     this.$swal("", error.response.statusText, "error");
                     this.$router.push({ name: "login" });
                     } else {
                     this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", error.message, "error");
                  }
               })
               .finally(() => (this.loading = false));
    },
         togglePassword() {
            if(this.show_password == false) {
               this.show_password = true;
            } else {
               this.show_password = false;
            }
         },

         toggleCurrentPassword() {
            if(this.show_current_password == false) {
               this.show_current_password = true;
            } else {
               this.show_current_password = false;
            }
         },

         toggleConfirmPassword() {
            if(this.show_confirm_password == false) {
               this.show_confirm_password = true;
            } else {
               this.show_confirm_password = false;
            }
         },

         changePassword() {

            this.getToken();
            this.errors = {};

            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            var data = JSON.stringify({
               "password": this.password,
               "password_confirmation": this.password_confirmation
            });
            
            this.loading = true;

            this.$axios
               .post("api/admin/change_password", data, config)
               .then((response) => {
                   console.log(response);

                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.$router.push({ name: "settings" });
               })
                .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } 
               else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         });
            //.finally(() => (this.loading = false));
         },

         clearForm() {
            this.password = "";
            this.password_confirmation = "";
          
            this.image = "";
            this.preview_image = "";
            this.settings.errors = "";

           

           
            this.errors = {};


         },

         
        updateCharges() {
            this.getToken();           
            this.errors = {};

            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/settings/delivery";

            let formData = new FormData();
            formData.append("delivery_range", this.settings.delivery_range);
            formData.append("delivery_cost", this.settings.delivery_cost);           
            
            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
               console.log(response);

                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.$router.push({ name: "settings" });
            })
            .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } 
               else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         });
            //.finally(() => (this.loading = false));
         },
        updateDeliveryTime() {
            this.getToken();           
            this.errors = {};

            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/settings/delivery-time";

            let formData = new FormData();
            formData.append("delivery_start", this.settings.delivery_start);
            formData.append("delivery_end", this.settings.delivery_end);           
            
            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
               console.log(response);

                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.$router.push({ name: "settings" });
            })
            .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } 
               else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         });
            //.finally(() => (this.loading = false));
         },
        
         updateMaintenance() {
            this.getToken();           
                        this.errors = {};

            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/settings/maintenance_update";

            let formData = new FormData();
            formData.append("maintenance_website", this.settings.maintenance_website);
            formData.append("maintenance_android", this.settings.maintenance_android);
            formData.append("maintenance_ios", this.settings.maintenance_ios);
                     formData.append("maintenance_android_delivery", this.settings.maintenance_android_delivery);
if(this.settings.maintenance_reason_website) {
               formData.append("maintenance_reason_website", this.settings.maintenance_reason_website); 
            }   else {
               formData.append("maintenance_reason_website", ""); 
            }          
  if(this.settings.maintenance_reason_android) {
               formData.append("maintenance_reason_android", this.settings.maintenance_reason_android); 
            }   else {
               formData.append("maintenance_reason_android", ""); 
            }          
if(this.settings.maintenance_reason_ios) {
               formData.append("maintenance_reason_ios", this.settings.maintenance_reason_ios); 
            }   else {
               formData.append("maintenance_reason_ios", ""); 
            }          
if(this.settings.maintenance_android_delivery) {
               formData.append("maintenance_reason_android_delivery", this.settings.maintenance_reason_android_delivery); 
            }   else {
               formData.append("maintenance_reason_android_delivery", ""); 
            }          

            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
      console.log(response);

                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.fetchSettings();
            })
            .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } 
               else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         });
            //.finally(() => (this.loading = false));
         },
         updateVersion() {
            this.getToken();           
                        this.errors = {};

            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/settings/version_control_update";

            let formData = new FormData();
            formData.append("app_store_version", this.settings.app_store_version);

            formData.append("app_store_update", this.settings.app_store_update);           
            formData.append("play_store_version", this.settings.play_store_version);           
            formData.append("play_store_update", this.settings.play_store_update);           
            formData.append("play_store_version_delivery", this.settings.play_store_version_delivery);           
            formData.append("play_store_update_delivery", this.settings.play_store_update_delivery);           

            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.fetchSettings();
            })
             .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } 
               else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         });
            //.finally(() => (this.loading = false));
         },
         updateURLs() {
            this.getToken();           
                        this.errors = {};

            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/settings/url_update";

            let formData = new FormData();
            formData.append("app_store_link", this.settings.app_store_link);
            formData.append("play_store_link", this.settings.play_store_link);           
            formData.append("play_store_link_delivery", this.settings.play_store_link_delivery);           
           
            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.fetchSettings();
            })
             .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } 
               else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         });
            //.finally(() => (this.loading = false));
         },

 updateSocialMedia() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "/api/admin/settings/social_media_link_update";

            let formData = new FormData();
            formData.append("facebook", this.settings.facebook);
            formData.append("instagram", this.settings.instagram);           
            formData.append("twitter", this.settings.twitter);           
                        formData.append("youtube", this.settings.youtube);           

            this.loading = true;            
            
            this.$axios
            .post(url, formData, config)      
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                        this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.fetchSettings();
            })
           .catch((error) => {
          console.log(error);
          console.log(error.response);
          if (error.response) {
            if (error.response.status == 422) {
              if (error.response.data) {
                this.errors = error.response.data.message;
              }
              this.$swal("", error.response.statusText, "error");
            } else if (error.response.status == 500) {
              this.$swal("", error.response.statusText, "error");
            } else if (error.response.status == 401) {
              this.$swal("", error.response.statusText, "error");
              this.$router.push({ name: "login" });
            } else {
              this.$swal("", "Something went wrong", "error");
            }
          } else {
            this.$swal("", error.message, "error");
          }
        });
      //.finally(() => (this.loading = false));
    },

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Admin Details</h4>
                  <b-form @submit.prevent="updateProfile()">
                     <b-row>
                        <b-col  md="4" lg="5" class="form-group">
                           <label class="control-label">Name </label>
                           <b-form-input v-model="admin.name" @keypress="alphaSpacesOnly" v-bind:class="{ 'is-invalid': Boolean(errors.name_en) }"></b-form-input>

                           <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col  md="4" lg="5" class="form-group">
                           <label class="control-label">Email</label>
                           <b-form-input v-model="admin.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>

                           <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                                                <b-col  md="4" lg="5" class="form-group">
                                    <label class="control-label">Phone <span class="text-danger">*</span></label>                               
                                    <b-input-group size="sm" prepend="+91">
                                       <b-form-input v-model="admin.mobile" @keypress="numbersOnly" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"></b-form-input>
                                    </b-input-group>
                                    <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                                      </b-col>


<b-col md="6" lg="10" class="form-group">
                           <label class="control-label">Admin image <span class="note">[Allowed Formats: jpg, jpeg, png.]</span></label><br>
                           <img v-if="admin.image" :src="$image_url + admin.image" class="avatar-sm mb-2" alt="" />
                           <input ref="fileinput" type="file" @change="setFile($event)" accept="image/*" class="form-control image-class"  v-bind:class="{ 'is-invalid': Boolean(errors.image) }"/>
  <img
                      v-if="preview_image"
                      class="avatar-sm mt-2"
                      :src="preview_image"
                    />

                  
                           <div class="note">Leave this field empty if you don't want to add/edit the image</div>

                           <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                           
                        </b-col>
                        <b-col md="3" lg="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="submit-button mb-3" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Change Password</h4>
                  <b-form @submit.prevent="changePassword()">
                     <b-row class="d-flex">
                        <b-col md="5" class="form-group">
                           <label class="control-label">Password</label>
                           <b-input-group>
                              <b-form-input type="password" v-model="password"  v-if="!show_password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <b-form-input type="text" v-model="password" v-else v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <b-input-group-text @click="togglePassword()">
                                 <i class="fas fa-eye" v-if="show_password"></i>
                                 <i class="fas fa-eye-slash" v-else></i>
                              </b-input-group-text>
                               
                               
                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-input-group>
                           
                        </b-col>

                        <b-col md="5" class="form-group">
                           <label class="control-label">Confirm Password</label>
                           <b-input-group>
                                 <b-form-input type="password" v-model="password_confirmation" v-if="!show_confirm_password" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>
                                 <b-form-input type="text" v-model="password_confirmation" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }" v-else></b-form-input>
                                 <b-input-group-text @click="toggleConfirmPassword()">
                                    <i class="fas fa-eye" v-if="show_confirm_password"></i>
                                    <i class="fas fa-eye-slash" v-else></i>
                                 </b-input-group-text>

                                 <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>                              
                           </b-input-group>
                        </b-col>

                        <b-col md="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                        
                     </b-row>
                  </b-form>
               </div>
            </div>

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Delivery</h4>
                  <b-form @submit.prevent="updateCharges()">
                     <b-row>
                        <b-col md="5" class="form-group">
                           <label class="control-label">Delivery Range
                           (in Kms)</label>
                           <input type="text" class="form-control" @keypress="numbersOnly" v-model="settings.delivery_range"  v-bind:class="{ 'is-invalid': Boolean(errors.delivery_range) }"/>
                           <div v-for="(val, index) in errors.delivery_range" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="5" class="form-group">
                           <label class="control-label">Delivery Cost
                                    (in Rs.)</label>
                           <input type="text" class="form-control" v-model="settings.delivery_cost"  v-bind:class="{ 'is-invalid': Boolean(errors.delivery_cost) }"/>
                           <div v-for="(val, index) in errors.delivery_cost" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        
                        <b-col md="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>
 <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-">Delivery Time</h4>
                  <b-form @submit.prevent="updateDeliveryTime()">
                     <b-row>
                        <b-col md="5" class="form-group">
                           <label class="control-label">Start
                  </label>
                           <b-form-timepicker  v-model="settings.delivery_start"  v-bind:class="{ 'is-invalid': Boolean(errors.delivery_start) }"/>
                           <div v-for="(val, index) in errors.delivery_start" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="5" class="form-group">
                           <label class="control-label">End
                                    </label>
                           <b-form-timepicker  v-model="settings.delivery_end"  v-bind:class="{ 'is-invalid': Boolean(errors.delivery_end) }"/>
                           <div v-for="(val, index) in errors.delivery_end" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                              
                           </div>
                        </b-col>

                        
                        <b-col md="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>


           

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Maintenance Mode</h4>
                  <b-form @submit.prevent="updateMaintenance()">
                     <b-row>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Website (Customer)</label>
                           <select v-model="settings.maintenance_website" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.maintenance_website) }" @change="settings.maintenance_reason_website=''">
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                           </select>
                           <div v-for="(val, index) in errors.maintenance_website" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Reason for Maintenance<span class="text-danger">*</span> </label>
                           <b-form-input v-model="settings.maintenance_reason_website" v-bind:class="{ 'is-invalid': Boolean(errors.maintenance_reason_website) }"></b-form-input>
                           <div v-for="(val, index) in errors.maintenance_reason_website" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        

                    </b-row>
                     <b-row>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Android (Customer)</label>
                           <select v-model="settings.maintenance_android" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.maintenance_android) }" @change="settings.maintenance_reason_android=''">
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                           </select>
                           <div v-for="(val, index) in errors.maintenance_android" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Reason for Maintenance<span class="text-danger">*</span></label>
                           <b-form-input v-model="settings.maintenance_reason_android" v-bind:class="{ 'is-invalid': Boolean(errors.maintenance_reason_android) }"></b-form-input>
                           <div v-for="(val, index) in errors.maintenance_reason_android" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        </b-row> 
                        <b-row>
                        <b-col md="3" class="form-group">
                           <label class="control-label">IOS (Customer)</label>
                           <select v-model="settings.maintenance_ios" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.maintenance_ios) }" @change="settings.maintenance_reason_ios=''">
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                           </select>
                           <div v-for="(val, index) in errors.maintenance_ios" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Reason for Maintenance<span class="text-danger">*</span></label>
                           <b-form-input v-model="settings.maintenance_reason_ios" v-bind:class="{ 'is-invalid': Boolean(errors.maintenance_reason_ios) }"></b-form-input>
                           <div v-for="(val, index) in errors.maintenance_reason_ios" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        </b-row> 
                     <b-row>
                        <b-col md="3" class="form-group">
                           <label class="control-label"> Android(Delivery Staff)</label>
                           <select v-model="settings.maintenance_android_delivery" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.maintenance_android_delivery) }" @change="settings.maintenance_reason_android_delivery=''">
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                           </select>
                           <div v-for="(val, index) in errors.maintenance_android_delivery" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="6" class="form-group">
                           <label class="control-label">Reason for Maintenance<span class="text-danger">*</span> </label>
                           <b-form-input v-model="settings.maintenance_reason_android_delivery" v-bind:class="{ 'is-invalid': Boolean(errors.maintenance_reason_android_delivery) }"></b-form-input>
                           <div v-for="(val, index) in errors.maintenance_reason_android_delivery" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        </b-row> 
                     
                        <b-row> 

                     <b-col class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                    </b-row>
                    
                  </b-form>

               </div>
            </div>

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Version Control</h4>
                  <b-form @submit.prevent="updateVersion()">
                     <b-row>
                        
                        <b-col md="3" class="form-group">
                           <label class="control-label">App Store Version(Customer)</label>
                           <input type="text" class="form-control"  v-model="settings.app_store_version" v-bind:class="{ 'is-invalid': Boolean(errors.app_store_version) }">
                           <div v-for="(val, index) in errors.app_store_version" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                       <b-col md="3" class="form-group">
                           <label class="control-label">Force Update</label>
                           <select v-model="settings.app_store_update" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.app_store_update) }">
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                           </select>
                           <div v-for="(val, index) in errors.app_store_update" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                       </b-row>
 <b-row>
                        
                        <b-col md="3" class="form-group">
                           <label class="control-label">Play Store Version(Customer)</label>
                           <input type="text" class="form-control"  v-model="settings.play_store_version" v-bind:class="{ 'is-invalid': Boolean(errors.play_store_version) }">
                           <div v-for="(val, index) in errors.play_store_version" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                       <b-col md="3" class="form-group">
                           <label class="control-label">Force Update</label>
                           <select v-model="settings.play_store_update" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.play_store_update) }">
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                           </select>
                           <div v-for="(val, index) in errors.play_store_update" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                       </b-row>
                     <b-row>
                        
                        <b-col md="3" class="form-group">
                           <label class="control-label">Play Store Version(Delivery Staff)</label>
                           <input type="text" class="form-control"  v-model="settings.play_store_version_delivery" v-bind:class="{ 'is-invalid': Boolean(errors.play_store_version_delivery) }">
                           <div v-for="(val, index) in errors.play_store_version_delivery" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                       <b-col md="3" class="form-group">
                           <label class="control-label">Force Update</label>
                           <select v-model="settings.play_store_update_delivery" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.play_store_update_delivery) }" >
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                           </select>
                           <div v-for="(val, index) in errors.play_store_update_delivery" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                       </b-row>
                     
                     
                       <b-row>

                        <b-col md="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>
<div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Mobile app URLs</h4>
                  <b-form @submit.prevent="updateURLs()">
                     <b-row>
                         <b-col md="6" class="form-group">
                           <label class="control-label">App Store Link (Customer)</label>
                           <b-form-input v-model="settings.app_store_link" v-bind:class="{ 'is-invalid': Boolean(errors.app_store_link) }"></b-form-input>
                           <div v-for="(val, index) in errors.app_store_link" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                       
                         </b-row>
 <b-row>
                         <b-col md="6" class="form-group">
                           <label class="control-label">Play Store Link (Customer)</label>
                           <b-form-input v-model="settings.play_store_link" v-bind:class="{ 'is-invalid': Boolean(errors.play_store_link) }"></b-form-input>
                           <div v-for="(val, index) in errors.play_store_link" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                       
                         </b-row>
                     <b-row>
                         <b-col md="6" class="form-group">
                           <label class="control-label">Play Store Link (Delivery Staff)</label>
                           <b-form-input v-model="settings.play_store_link_delivery" v-bind:class="{ 'is-invalid': Boolean(errors.play_store_link_delivery) }"></b-form-input>
                           <div v-for="(val, index) in errors.play_store_link_delivery" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                       
                         </b-row>
                     
                     
                       <b-row>

                        <b-col md="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>

 <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Social Media Links</h4>
                  <b-form @submit.prevent="updateSocialMedia()">
                     <b-row>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Youtube</label>
                           <b-form-input v-model="settings.youtube" v-bind:class="{ 'is-invalid': Boolean(errors.youtube) }"></b-form-input>
                           <div v-for="(val, index) in errors.youtube" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        
                        <b-col md="3" class="form-group">
                           <label class="control-label">Facebook</label>
                           <b-form-input v-model="settings.facebook" v-bind:class="{ 'is-invalid': Boolean(errors.facebook) }"></b-form-input>
                           <div v-for="(val, index) in errors.facebook" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Twitter</label>
                           <b-form-input v-model="settings.twitter" v-bind:class="{ 'is-invalid': Boolean(errors.twitter) }"></b-form-input>
                           <div v-for="(val, index) in errors.twitter" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        <b-col md="3" class="form-group">
                           <label class="control-label">Instagram</label>
                           <b-form-input v-model="settings.instagram" v-bind:class="{ 'is-invalid': Boolean(errors.instagram) }"></b-form-input>
                           <div v-for="(val, index) in errors.instagram" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                        
                        <b-col md="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>

         </div>
      </div>
   </Layout>
</template>
